export const isRegisteredCheckout = (
  userType?: string | null,
  idt?: string | null
): boolean => userType === "loggedIn" || Boolean(idt);
